import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { QuestionType } from "@/types/survey";
import { QuestionCard } from "./QuestionCard";

interface SortableQuestionCardProps {
  question: QuestionType;
  index: number;
  onChange: (question: QuestionType) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  isDragging: boolean;
  surveyId?: number;
  allQuestions?: QuestionType[];  // For "copy regions between questions" (Phase 4)
}

export function SortableQuestionCard({
  question,
  index,
  onChange,
  onDelete,
  onDuplicate,
  isDragging,
  surveyId,
  allQuestions,
}: SortableQuestionCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({ id: question.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isSortableDragging ? 0.5 : 1,
    zIndex: isSortableDragging ? 1000 : 1,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <QuestionCard
        question={question}
        index={index}
        onChange={onChange}
        onDelete={onDelete}
        onDuplicate={onDuplicate}
        isDragging={isDragging || isSortableDragging}
        dragHandleProps={{ ...attributes, ...listeners }}
        surveyId={surveyId}
        allQuestions={allQuestions}
      />
    </div>
  );
}

